export default __webpack_public_path__ + "static/tcofs-e01936b854286a75b52d8ad303b87147.jpg";